import { styles } from "./form";
import { useFormik } from "formik";
import { EnSchema, initialValues } from "./en_schema";
import { ArSchema } from "./ar_schema";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useI18n} from "@/i18n/I18nProvider"
import { arFont, enFont } from "@/styles/font";
import { submitForm } from "../../utils/become_partner";

export default function Form({ color }) {
 const { t, locale } = useI18n();
  const sortedCategories = [...t.CategoriesForm1].sort();
  const onSubmit = async (values, actions) => {
    await submitForm("25", values, actions, t);
  };
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: locale === "en" ? EnSchema : ArSchema,
    onSubmit,
  });
  return (
    <Box
      component="form"
      sx={styles.container}
      onSubmit={handleSubmit}
      autoComplete="off"
      noValidate
      style={{
        padding: "24px",
        borderRadius: "16px",
      }}
    >
      <Box>
        <Box sx={styles.label}>{t.have_record}</Box>
        <RadioGroup
          value={values.commercialTax || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <FormControlLabel
            control={
              <Radio
                onClick={() => {
                  setFieldValue("commercialTax", "yes");
                }}
                value="yes"
                sx={{
                  "&.Mui-checked": {
                    color: "#F18222",
                  },
                }}
              />
            }
            label={t.yes}
          />
          <FormControlLabel
            control={
              <Radio
                onClick={() => {
                  setFieldValue("commercialTax", "no");
                }}
                value="no"
                sx={{
                  "&.Mui-checked": {
                    color: "#F18222",
                  },
                }}
              />
            }
            label={t.no}
          />
        </RadioGroup>
        <Box sx={styles.helperText}>
          {touched.commercialTax && errors.commercialTax}
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "10px",
          flexWrap: { xs: "wrap", md: "initial" },
        }}
      >
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
<InputLabel
  sx={(theme) => ({
    ...styles.label(theme),
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset",
    wordBreak: "break-word",
  })}
>
  {t.company_nameForm1}
</InputLabel>
          <TextField
            value={values.company_name}
            onChange={handleChange}
            id="company_name"
            type="text"
            onBlur={handleBlur}
            error={touched.company_name && errors.company_name}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>
            {touched.company_name && errors.company_name}
          </Box>
        </Box>
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.specialist_name}</InputLabel>
          <TextField
            value={values.specialist_name}
            onChange={handleChange}
            id="specialist_name"
            type="text"
            onBlur={handleBlur}
            error={touched.specialist_name && errors.specialist_name}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>
            {touched.specialist_name && errors.specialist_name}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "10px",
          flexWrap: { xs: "wrap", md: "initial" },
        }}
      >
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.phone}</InputLabel>
          <TextField
            value={values.phoneNumber}
            onChange={(event) => {
              const validInput = event.target.value.replace(/[^0-9]/g, "");
              if (validInput.length <= 11) {
                event.target.value = validInput;
                handleChange(event);
              }
            }}
            id="phoneNumber"
            type="text"
            onBlur={handleBlur}
            error={touched.phoneNumber && errors.phoneNumber}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>
            {touched.phoneNumber && errors.phoneNumber}
          </Box>
        </Box>
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.email}</InputLabel>
          <TextField
            value={values.email}
            onChange={handleChange}
            id="email"
            type="text"
            onBlur={handleBlur}
            error={touched.email && errors.email}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>{touched.email && errors.email}</Box>
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel sx={styles.label}>{t.categories}</InputLabel>
        <TextField
          value={values.categories || "default"}
          onChange={handleChange}
          id="categories"
          name="categories"
          select
          onBlur={handleBlur}
          error={touched.categories && errors.categories}
          sx={styles.input}
          variant="outlined"
          style={{ height: "45px" }}
          InputProps={{
            sx: {
              height: "45px",
              color: "grey",
              lineHeight: "2",
            },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  marginTop: 1,
                  maxHeight: 300,
                },
              },
            },
          }}
        >
          <MenuItem
            disabled
            value="default"
            className={locale == "en" ? enFont.className : arFont.className}
            sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
          >
            {t.form_labels.cat_placeholder}
          </MenuItem>
          {sortedCategories.map((category, index) => (
            <MenuItem
              key={index}
              value={category}
              className={locale == "en" ? enFont.className : arFont.className}
              sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
            >
              {category}
            </MenuItem>
          ))}
        </TextField>
        <Box sx={styles.helperText}>
          {touched.categories && errors.categories}
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel sx={styles.label}>{t.url}</InputLabel>
        <TextField
          value={values.url}
          onChange={handleChange}
          id="url"
          type="url"
          onBlur={handleBlur}
          error={touched.url && errors.url}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>{touched.url && errors.url}</Box>
      </Box>
      <Box>
        <Box sx={styles.label}>{t.digital}</Box>
        <RadioGroup
          value={values.eCommerce || ""}
          onChange={handleChange}
          onBlur={handleBlur} // Ensure it marks as touched when blurred
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <FormControlLabel
            control={
              <Radio
                onClick={() => {
                  setFieldValue("eCommerce", "yes");
                }}
                value="yes"
                sx={{
                  "&.Mui-checked": {
                    color: "#F18222",
                  },
                }}
              />
            }
            label={t.yes}
          />
          <FormControlLabel
            control={
              <Radio
                onClick={() => {
                  setFieldValue("eCommerce", "no");
                }}
                value="no"
                sx={{
                  "&.Mui-checked": {
                    color: "#F18222",
                  },
                }}
              />
            }
            label={t.no}
          />
        </RadioGroup>
        <Box sx={styles.helperText}>
          {touched.eCommerce && errors.eCommerce}
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel sx={styles.label}>{t.address}</InputLabel>
        <TextField
          value={values.address}
          onChange={handleChange}
          id="address"
          type="text"
          onBlur={handleBlur}
          error={touched.address && errors.address}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>{touched.address && errors.address}</Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "10px",
          flexWrap: { xs: "wrap", md: "initial" },
        }}
      >
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.governorate}</InputLabel>
          <TextField
            value={values.governorate || "default"}
            onChange={handleChange}
            name="governorate"
            type="text"
            onBlur={handleBlur}
            error={touched.governorate && errors.governorate}
            sx={styles.input}
            select
            style={{ height: "45px" }}
            InputProps={{
              sx: {
                height: "45px",
                color: "grey",
                lineHeight: "2",
              },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    marginTop: 1,
                    maxHeight: 300,
                  },
                },
              },
            }}
          >
            <MenuItem
              disabled
              value="default"
              className={locale == "en" ? enFont.className : arFont.className}
              sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
            >
              {t.form_labels.g_placeholder}
            </MenuItem>
            {t.governorates.map((option) => (
              <MenuItem
                key={option.id}
                value={option.governorate_name}
                className={locale == "en" ? enFont.className : arFont.className}
                sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
              >
                {option.governorate_name}
              </MenuItem>
            ))}
          </TextField>
          <Box sx={styles.helperText}>
            {touched.governorate && errors.governorate}
          </Box>
        </Box>
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.branchesNumber}</InputLabel>
          <TextField
            value={values.branch_number}
            onChange={(event) => {
              const validInput = event.target.value.replace(/[^0-9]/g, "");
              event.target.value = validInput;
              handleChange(event);
            }}
            id="branch_number"
            type="text"
            onBlur={handleBlur}
            error={touched.branch_number && errors.branch_number}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>
            {touched.branch_number && errors.branch_number}
          </Box>
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
<InputLabel
  sx={(theme) => ({
    ...styles.label(theme),
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset",
    wordBreak: "break-word",
  })}
>
  {t.POS}
</InputLabel>
        <TextField
          value={values.POS || "default"}
          onChange={handleChange}
          name="POS"
          type="text"
          onBlur={handleBlur}
          error={touched.POS && errors.POS}
          sx={styles.input}
          select
          style={{ height: "45px" }}
          InputProps={{
            sx: {
              height: "45px",
              color: "grey",
              lineHeight: "2",
            },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  marginTop: 1,
                  maxHeight: 300,
                },
              },
            },
            placeholder: t.form_labels.POS_Placeholder,
          }}
        >
          <MenuItem
            disabled
            value="default"
            className={locale == "en" ? enFont.className : arFont.className}
            sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
          >
            {t.form_labels.POS_Placeholder}
          </MenuItem>
          {t.POSform1.map((option, index) => (
            <MenuItem
              key={index}
              value={option}
              className={locale == "en" ? enFont.className : arFont.className}
              sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>
        <Box sx={styles.helperText}>{touched.POS && errors.POS}</Box>
      </Box>
      <Button
        aria-label="contact us submit button "
        disabled={isSubmitting}
        type="submit"
        sx={styles.btn}
        style={{
          backgroundColor: isSubmitting ? "#d3d3d3" : color,
          border: `1px solid #74357D`,
        }}
      >
        {isSubmitting ? (
          <CircularProgress size={24} sx={{ color: "#9e9e9e" }} />
        ) : (
          t.send
        )}
      </Button>
    </Box>
  );
}
